<template>
  <a-layout
    id="components-layout-demo-side"
    class="AAA"
    style="min-height: 100vh"
  >
    <!-- 左侧边栏 -->
    <a-layout-sider v-model="collapsed" collapsible class="sider" fixed>
      <div class="logo">{{ collapsed ? shortName : shopName }}</div>
      <a-menu theme="dark" :default-selected-keys="['1']" mode="inline">
        <template v-for="item in rightList">
          <template v-if="!item.children">
            <a-menu-item :key="item.name" @click="openMenu(`/home/${item.path}`, item.name)">
              <!-- <a-icon :type="item.icon" /> -->
              <span>{{ item.name }}</span>
            </a-menu-item>
          </template>

          <template v-else>
            <a-sub-menu :title="item.name" :key="item.objId">
              <a-menu-item
                v-for="k in item.children"
                :key="k.objId"
                @click="openMenu(`/home/${k.path}`, k.name)"
              >
                <span>{{ k.name }}</span>
              </a-menu-item>
            </a-sub-menu>
          </template>
        </template>
      </a-menu>
    </a-layout-sider>

    <a-layout>
      <a-row>
        <a-col :span="24">
          <a-layout-header style="background: #fff; padding: 0" class="header">
            <a-icon
              class="trigger"
              :type="collapsed ? 'menu-unfold' : 'menu-fold'"
              @click="() => (collapsed = !collapsed)"
            />
            <div class="head">
              <a-dropdown>
                <img
                  src="https://img2.baidu.com/it/u=3973855039,4170930478&fm=253&fmt=auto&app=138&f=PNG?w=500&h=500"
                  alt=""
                />
                <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                  Hover me <a-icon type="down" />
                </a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a href="javascript:;" @click="clear">退出登录</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
              <span class="name">{{ shopName + roleName }}</span>
            </div>
            <div></div>
          </a-layout-header>
        </a-col>
      </a-row>
      <!-- 历史标签页 -->
      <a-row>
        <a-col :span="24">
          <div
            class="history-tabs"
            :style="{ left: collapsed ? '80px' : '200px' }"
          >
            <div
              v-for="tab in tabs"
              :key="tab.path"
              class="history-tab"
              :class="{ 'is-active': tab.path === currentPath }"
              @click="goTab(tab)"
            >
              <span class="history-tab-title">{{ tab.title }}</span>
              <a-icon
                v-if="tab.closable"
                type="close"
                class="history-tab-close"
                @click.stop="closeTab(tab)"
              />
            </div>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24"> <router-view class="main"></router-view></a-col>
      </a-row>
    </a-layout>
  </a-layout>
</template>
<script>
import { message } from "ant-design-vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      collapsed: false,
      rightList: [],
      headImg: "",
      roleName: "",
      shopName: "",
      shortNmae: "",
      tabs: [],
      currentPath: "",
      menuNameMap: {},
    };
  },
  watch: {
    $route(val) {
      this.currentPath = val.path;
      this.addTab(val);
    },
  },
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    clear() {
      this.$router.go({ name: "login" });
      sessionStorage.clear();
      message.success("退出成功");
    },
    // 记录一个历史标签
    addTab(route) {
      if (!route || !route.path || !route.path.startsWith("/home")) return;
      if (route.path === "/home" || route.path === "/home/") return;
      if (this.tabs.find((t) => t.path === route.path)) return;
      console.log(
        "[history-tabs] addTab:",
        route.path,
        "记录名:",
        this.menuNameMap[this.normPath(route.path)],
        "匹配名:",
        this.findMenuName(route.path),
        "路由名:",
        route.name
      );
      this.tabs.push({
        path: route.path,
        title: this.getTabTitle(route),
        closable: true,
      });
    },
    // 菜单点击：记录 路由→菜单名 映射，保证标签标题为中文
    openMenu(routePath, menuName) {
      if (menuName) {
        this.$set(this.menuNameMap, this.normPath(routePath), menuName);
      }
      this.$router.push(routePath);
    },
    // 路由路径规范化（去掉多余斜杠与末尾斜杠）
    normPath(p) {
      return String(p).replace(/\/+/g, "/").replace(/\/$/, "");
    },
    // 路径清理：去多余斜杠、去 /home 前缀，得到相对路径
    cleanPath(p) {
      return this.normPath(p).replace(/^\/?home\/?/, "");
    },
    // 标签标题：优先点击记录的中文名（含父级前缀匹配），再按菜单匹配
    getTabTitle(route) {
      // 首页特殊处理：登录/刷新后默认进入首页，无菜单点击记录
      const rel = this.cleanPath(route.path);
      const last = rel.split("/").pop();
      if (
        last === "homeContent" ||
        last === "homeContentTwo" ||
        route.name === "homeContent" ||
        route.name === "homeContentTwo"
      ) {
        return "首页";
      }
      const key = this.normPath(route.path);
      if (this.menuNameMap[key]) return this.menuNameMap[key];
      const fromMap = this.matchMapPrefix(route.path);
      if (fromMap) return fromMap;
      const menuName = this.findMenuName(route.path);
      if (menuName) return menuName;
      return route.name || route.path;
    },
    // 点击记录中按父级前缀匹配（父菜单 redirect 到子路由的情况）
    matchMapPrefix(path) {
      const target = this.cleanPath(path);
      let bestKey = "";
      Object.keys(this.menuNameMap).forEach((k) => {
        const kp = this.cleanPath(k);
        if (kp && target.startsWith(kp + "/") && kp.length > this.cleanPath(bestKey).length) {
          bestKey = k;
        }
      });
      return bestKey ? this.menuNameMap[bestKey] : "";
    },
    // 菜单匹配：精确优先，其次父级前缀（取最长匹配）
    findMenuName(path) {
      const target = this.cleanPath(path);
      const menus = this.collectMenus(this.rightList || []);
      const exact = menus.find((m) => m.path === target);
      if (exact) return exact.name;
      let best = null;
      menus.forEach((m) => {
        if (m.path && target.startsWith(m.path + "/")) {
          if (!best || m.path.length > best.path.length) best = m;
        }
      });
      return best ? best.name : "";
    },
    // 扁平化菜单数据
    collectMenus(list, out) {
      out = out || [];
      (list || []).forEach((item) => {
        if (item.path) out.push({ path: this.cleanPath(item.path), name: item.name });
        if (item.children && item.children.length) this.collectMenus(item.children, out);
      });
      return out;
    },
    // 点击标签切换页面
    goTab(tab) {
      if (tab.path !== this.currentPath) {
        this.$router.push(tab.path);
      }
    },
    // 关闭标签
    closeTab(tab) {
      const index = this.tabs.findIndex((t) => t.path === tab.path);
      if (index === -1) return;
      this.tabs.splice(index, 1);
      if (tab.path === this.currentPath) {
        const next = this.tabs[index] || this.tabs[index - 1];
        if (next) {
          this.$router.push(next.path);
        } else {
          this.$router.push("/home/homeContent");
        }
      }
    },
  },
  created() {
    this.headImg = sessionStorage.getItem("headImg");
    this.roleName = sessionStorage.getItem("roleName") || "管理员";
    this.rightList = JSON.parse(sessionStorage.getItem("menudata"));
    this.shopName = sessionStorage.getItem("shopName");
    if (this.shopName == "undefined" || this.shopName == null || this.shopName == "") {
      this.shopName = "八达管理后台";
    }
    this.shortName = this.shopName.slice(0, 2);
    this.currentPath = this.$route.path;
    this.addTab(this.$route);

  },
  computed: {
    // ...mapState(["rightList"]),
  },
};
</script>
<style lang="sass" scoped>
.name
  position: relative
  left: 600px

img
  border-radius: 50%
  width: 50px
  height: 50px
  position: relative
  left: 600px

.sider
  height: 100vh
  overflow-y: auto
  margin-bottom: 43px

  &::-webkit-scrollbar
    display: none

.header
  position: fixed
  display: flex
  justify-content: space-between
  align-items: center
  width: 100vw
  z-index: 5

.history-tabs
  position: fixed
  top: 66px
  right: 0
  height: 40px
  display: flex
  align-items: center
  background: #fff
  border-bottom: 1px solid #e8e8e8
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06)
  padding: 0 16px
  overflow-x: auto
  overflow-y: hidden
  white-space: nowrap
  z-index: 4

  &::-webkit-scrollbar
    height: 4px

  &::-webkit-scrollbar-thumb
    background: #d9d9d9
    border-radius: 2px

.history-tab
  display: inline-flex
  align-items: center
  flex: 0 0 auto
  height: 26px
  padding: 0 10px
  margin-right: 8px
  border: 1px solid #d9d9d9
  border-radius: 4px
  background: #fff
  color: #595959
  font-size: 12px
  line-height: 24px
  cursor: pointer
  user-select: none

  &.is-active
    color: #1890ff
    border-color: #1890ff
    background: #e6f7ff

.history-tab-title
  max-width: 140px
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap

.history-tab-close
  margin-left: 6px
  font-size: 10px
  color: #bfbfbf

  &:hover
    color: #1890ff

.main
  position: relative
  top: 106px
  height: 100vh
  overflow-y: auto

  &::-webkit-scrollbar
    display: none

#components-layout-demo-side .logo
  color: #fff
  text-align: center
  line-height: 32px
  font-size: 19px
  height: 32px
  margin: 16px

#components-layout-demo-side .trigger
  font-size: 18px
  line-height: 64px
  padding: 0 24px
  cursor: pointer
  transition: color 0.3s

  &:hover
    color: #1890ff
</style>


// WEBPACK FOOTER //
// src/views/home/home.vue